import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const Aside = styled.aside`
    padding: 1rem;
    display: flex;
    gap: 1rem;
    border: 1px solid ${colourScheme.white};
    border-radius: 0.5rem;
    background-color: ${colourScheme.primaryDark};
`;

export const Emoji = styled.span`
    margin-right: 0.5rem;
    align-self: center;
`;
